const platform = () => {
  return isMobile() ? 'mobile' : 'desktop'
}

export const isMobile = () => {
  return /iPhone|iPod|iPad|Android/i.test(navigator.userAgent)
}

export const isAndroid = () => {
  return /Android/i.test(navigator.userAgent)
}

export const isApple = () => {
  return /iPhone|iPod|iPad/i.test(navigator.userAgent)
}

const determineDeviceType = () => {
  if (isApple()) {
    return 'ios'
  } else if (isAndroid()) {
    return 'android'
  }
  return 'desktop'
}

export const deviceType = determineDeviceType()

export default platform()
